import { Link } from "react-router-dom";

export default function PrivacyPolicyPage() {
  return (
    <div className="pt-20 min-h-screen bg-kerala-cream" data-testid="privacy-policy-page">
      {/* Header */}
      <section className="bg-kerala-green py-16">
        <div className="section-container text-center">
          <h1 className="font-heading text-4xl md:text-5xl text-white mb-4">Privacy Policy</h1>
          <p className="text-white/80">Last updated: February 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="section-container max-w-4xl">
          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 space-y-8">
            
            <div>
              <h2 className="font-heading text-2xl text-kerala-green mb-4">1. Introduction</h2>
              <p className="text-gray-700 leading-relaxed">
                Tatvamasi - Kerala Hindu's of London Ontario ("we", "our", or "us") is committed to protecting your privacy. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our 
                website and use our services, including event registration and ticket purchasing.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-kerala-green mb-4">2. Information We Collect</h2>
              <p className="text-gray-700 leading-relaxed mb-4">We may collect the following types of information:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li><strong>Personal Information:</strong> Name, email address, phone number, mailing address</li>
                <li><strong>Family Information:</strong> Spouse name, children's names (if provided during registration)</li>
                <li><strong>Payment Information:</strong> Processed securely through Stripe; we do not store credit card details</li>
                <li><strong>Event Participation:</strong> Event registrations, ticket purchases, attendance records</li>
                <li><strong>Technical Data:</strong> IP address, browser type, device information for website functionality</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-kerala-green mb-4">3. How We Use Your Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4">We use the collected information to:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Process event registrations and ticket purchases</li>
                <li>Send confirmation emails and event updates</li>
                <li>Communicate about upcoming events and community activities</li>
                <li>Manage membership and community participation</li>
                <li>Improve our website and services</li>
                <li>Comply with legal obligations</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-kerala-green mb-4">4. Information Sharing</h2>
              <p className="text-gray-700 leading-relaxed">
                We do not sell, trade, or rent your personal information to third parties. We may share information with:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mt-4">
                <li><strong>Service Providers:</strong> Payment processors (Stripe), email services, and hosting providers</li>
                <li><strong>Event Partners:</strong> Venue operators for event management purposes only</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-kerala-green mb-4">5. Data Security</h2>
              <p className="text-gray-700 leading-relaxed">
                We implement appropriate technical and organizational measures to protect your personal information. 
                Payment processing is handled by Stripe, which is PCI-DSS compliant. However, no method of transmission 
                over the Internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-kerala-green mb-4">6. Your Rights</h2>
              <p className="text-gray-700 leading-relaxed mb-4">You have the right to:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Access your personal information</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt-out of marketing communications</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-kerala-green mb-4">7. Cookies</h2>
              <p className="text-gray-700 leading-relaxed">
                Our website may use cookies and similar technologies to enhance your experience. 
                These are used for session management and remembering your preferences. 
                You can control cookies through your browser settings.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-kerala-green mb-4">8. Children's Privacy</h2>
              <p className="text-gray-700 leading-relaxed">
                Our services are not directed to children under 13. We do not knowingly collect personal 
                information from children under 13. If you believe we have collected information from a child, 
                please contact us immediately.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-kerala-green mb-4">9. Changes to This Policy</h2>
              <p className="text-gray-700 leading-relaxed">
                We may update this Privacy Policy from time to time. We will notify you of any changes by 
                posting the new Privacy Policy on this page and updating the "Last updated" date.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-kerala-green mb-4">10. Contact Us</h2>
              <p className="text-gray-700 leading-relaxed">
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <div className="mt-4 p-4 bg-kerala-cream rounded-lg">
                <p className="text-gray-700"><strong>Email:</strong> tatvamasilondonontario@gmail.com</p>
                <p className="text-gray-700"><strong>Location:</strong> London, Ontario, Canada</p>
              </div>
            </div>

            <div className="pt-8 border-t border-gray-200">
              <Link to="/" className="text-kerala-green hover:text-kerala-gold transition-colors">
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
